import { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Link, Typography } from '@mui/material'
import { APP_NAME } from '@config/app.config'

interface AuthLayoutProps {
  children: ReactNode
}

/**
 * Frame for the signed-out pages (login, MFA, password reset). The pages bring their own Card;
 * this only centres it, caps its width and adds the brand header and footer. Styled with sx
 * because the old class names pointed at a stylesheet that no longer exists.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        bgcolor: 'background.default',
        px: { xs: 1.5, sm: 3 },
        py: { xs: 2, sm: 4 },
      }}
    >
      <Box component="header" sx={{ textAlign: 'center', mb: { xs: 2, sm: 3 } }}>
        <Link component={RouterLink} to="/" underline="none" color="inherit">
          <Typography variant="h5" component="div" sx={{ fontWeight: 700 }}>
            {APP_NAME}
          </Typography>
        </Link>
      </Box>

      {/* flex:1 + centring keeps the card mid-screen on tall displays without pushing the
          footer off a short phone screen */}
      <Box
        component="main"
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: 480,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {children}
      </Box>

      <Box component="footer" sx={{ mt: { xs: 2, sm: 3 }, textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          &copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.
        </Typography>
      </Box>
    </Box>
  )
}
